import { getJSON } from 'bv-fetch';
import { logged_account_number as accountNumber } from 'state';

let quickStakes;

export default () => {
  quickStakes = quickStakes || getJSON('/api/quick_stakes', { l: accountNumber() })
    .catch(() => ({
      bySportId: [],
      default: [],
    }));

  return quickStakes;
};
